module.exports = __webpack_public_path__ + "images/emoji/restroom.5cebf98068a17cf6eb5d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/restroom.png
// module id = m7Wu
// module chunks = 14